<template>

  <div id="app_content" class="public">
    <div class="section top" :style="'background-image: url('+url('/media/image-page/banner-home-def.jpg')+');'">
      <div class="section-container-center-mode">
        <div class="content">
          <div class="form-register bf-sat-blur">
            <h2>Registrazione nuovo utente</h2>
            <div class="row">
              <div class="col-md-8">
                <b-field id="ragionesociale"
                         class="form-group"
                         label="Ragione Sociale"
                         :message="messageInput.ragionesociale.message"
                         :type="(messageInput.ragionesociale.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input
                      v-model="formInput.ragionesociale"
                      v-on:blur="validateField('ragionesociale')"
                      :disabled="disableInput"></b-input>
                </b-field>
              </div>
              <div class="col-md-4">
                <b-field id="partitaiva"
                         class="form-group"
                         label="Partita Iva"
                         :message="messageInput.partitaiva.message"
                         :type="(messageInput.partitaiva.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input
                      v-model="formInput.partitaiva"
                      v-on:blur="validateField('partitaiva')"
                      maxlength="11"
                      :disabled="disableInput"></b-input>
                </b-field>
              </div>
              <div class="col-12">
                <b-field id="indirizzo"
                         class="form-group"
                         label="Indirizzo"
                         :message="messageInput.indirizzo.message"
                         :type="(messageInput.indirizzo.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.indirizzo"
                           v-on:blur="validateField('indirizzo')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-3">
                <b-field id="cap"
                         class="form-group"
                         label="CAP"
                         :message="messageInput.cap.message"
                         :type="(messageInput.cap.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.cap"
                           v-on:blur="validateField('cap')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6">
                <b-field id="comune"
                         class="form-group"
                         label="Comune"
                         :message="messageInput.comune.message"
                         :type="(messageInput.comune.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.comune"
                           v-on:blur="validateField('comune')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-3">
                <b-field id="provincia"
                         class="form-group"
                         label="Provincia"
                         :message="messageInput.provincia.message"
                         :type="(messageInput.provincia.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.provincia"
                           v-on:blur="validateField('provincia')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6">
                <b-field id="ntelefono"
                         class="form-group"
                         label="N. di telefono"
                         :message="messageInput.ntelefono.message"
                         :type="(messageInput.ntelefono.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.ntelefono"
                           v-on:blur="validateField('ntelefono')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6">
                <b-field id="fax"
                         class="form-group"
                         label="Fax"
                         :message="messageInput.fax.message"
                         :type="(messageInput.fax.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.fax"
                           v-on:blur="validateField('fax')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6 mt-5">
                <b-field id="username"
                         class="form-group"
                         label="Username"
                         :message="messageInput.username.message"
                         :type="(messageInput.username.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input v-model="formInput.username"
                           icon="account"
                           maxlength="32"
                           v-on:blur="validateField('username')"
                           :disabled="disableInput">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6 mt-5">
                <b-field id="email"
                         class="form-group"
                         label="Email"
                         :message="messageInput.email.message"
                         :type="(messageInput.email.error) ? 'is-danger' : '' "
                         label-position="inside">
                  <b-input type="text"
                           v-on:blur="validateField('email')"
                           :disabled="disableInput"
                           icon="email"
                           v-model="formInput.email"
                           maxlength="32">
                  </b-input>
                </b-field>
              </div>
              <div class="col-6">
                <b-field id="password"
                         class="form-group"
                         label="Password"
                         :message="messageInput.password.message"
                         label-position="inside"
                         :type="(messageInput.password.error) ? 'is-danger' : '' "
                         :disabled="disableInput">

                  <b-input type="password" maxlength="30"
                           v-on:blur="validateField('password')"
                           icon="key"
                           :disabled="disableInput"
                           v-model="formInput.password">

                  </b-input>
                </b-field>
              </div>
              <div class="col-6">
                <b-field id="password2"
                         class="form-group"
                         label="Ripeti password"
                         label-position="inside"
                         :message="messageInput.password2.message"
                         :type="(messageInput.password2.error) ? 'is-danger' : '' ">
                  <b-input type="password"
                           maxlength="30"
                           :disabled="disableInput"
                           icon="key"
                           v-on:blur="validateField('password2')"
                           v-model="formInput.password2">

                  </b-input>
                </b-field>
              </div>

            </div>
            <div class="btns">
              <a class="link-ret green" @click="sendForm">Registrazione</a>
              <a class="link-ret btn-my-primary black" @click="resetForm">Reset</a>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
//https://github.com/gs-shop/vue-slick-carousel/blob/master/docs/API.md#props

// import Login from './../login'
// import Login from './../form-contact'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
//import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
//import VueFullPage from 'vue-fullpage.js'

export default {

  components: { /*Login ,*/ /*VueFullPage, 'v-slick': VueSlickCarousel*/},

  data: function () {

    return {
      opened_float_login: false,

      formInput: {
        ragionesociale: "",
        partitaiva: "",
        indirizzo: "",
        cap: "",
        comune: "",
        provincia: "",
        ntelefono: "",
        fax: "",
        username: "",
        email: "",
        password: "",
        password2: "",
      },
      messageInput: {
        ragionesociale: {
          error: null,
          message: ""
        },
        partitaiva: {
          error: null,
          message: ""
        },
        indirizzo: {
          error: null,
          message: ""
        },
        cap: {
          error: null,
          message: ""
        },
        comune: {
          error: null,
          message: ""
        },
        provincia: {
          error: null,
          message: ""
        },
        ntelefono: {
          error: null,
          message: ""
        },
        fax: {
          error: null,
          message: ""
        },
        username: {
          error: null,
          message: ""
        },
        email: {
          error: null,
          message: ""
        },
        password: {
          error: null,
          message: ""
        },
        password2: {
          error: null,
          message: ""
        },
      },

      disableInput: false,
      isFullPage: true,


      isMounted: false,
      slickOptions: {
        lockAnchors: true,

        focusOnSelect: false,
        rtl: false,
        draggable: false,
        slidesToShow: 3,
        centerMode: true, //
        swipeToSlide: false,
        touchMove: false,
        infinite: true,
        arrows: true,
        responsive: [
          {
            "breakpoint": 500,
            "settings": {
              "slidesToShow": 2,
              "slidesToScroll": 1
            }
          },
        ]
      },


    }

  },

  created: function () {

    this.isMounted = true;

  },

  mounted: function () {


  },

  computed: {},

  methods: {
    errorToast(message) {
      this.$buefy.toast.open({
        duration: 5000,
        message: message,
        position: 'is-bottom',
        type: 'is-danger',
        container: '.form-register'
      })
    },
    alertSuccess(username) {
      this.$buefy.dialog.alert({
        title: 'Registrazione',
        message: `Grazie ${username}, registrazione avvenuta con successo.<br> Riceverai una e-mail per confermare l'account.`,
        confirmText: 'Ok',
        type: 'is-success',
        //onConfirm: () => window.location.replace('/')
      })
    },
    validateField: function (fieldname) {
      for (let key in this.formInput) {
        if (fieldname === key) {
          var input = this.formInput[key]
        }
      }
      for (let key in this.messageInput) {
        if (fieldname === key) {
          var output = this.messageInput[key]

        }
      }

      if (input.length < 1) {
        output.message = "Campo obbligatorio"
        output.error = true

      } else {
        var error = false
        if (fieldname === 'username' || fieldname === 'password') {
          if (input.length < 8) {
            output.message = "Almeno 8 caratteri"
            output.error = true
            error = true
          } else {
            output.message = ""
            output.error = false
          }
        } else if (fieldname === 'partitaiva') {
          if (input.length < 11) {
            output.message = "Richieste 11 cifre"
            output.error = true
            error = true
          } else if (isNaN(input)) {
            output.message = "Inserire solo valori numerici"
            output.error = true
            error = true
          } else {
            output.message = ''
            output.error = false
          }
        } else if (fieldname === 'email') {
          if (!this.validateEmail(input)){
            output.message = "Formato email non corretto"
            output.error = true
            error = true
          } else {
            output.message = ''
            output.error = false
          }
        }
        if (!error) {
          output.error = false
          output.message = ""
        }
      }


    },

    validateEmail: function (email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    resetForm: function () {
      for (let key in this.formInput) {
        this.formInput[key] = ''
      }
    },
    sendForm: function () {
      //this.disableInput = true
      const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el
      })
      let error = false
      if (this.formInput.password === this.formInput.password2) {
        for (let key in this.messageInput) {
          if (this.messageInput[key].error) {
            error = true
          }
        }
        if (!error) {
          axios({
            method: 'post',
            url: window.location.origin + '/data/register-user',
            params: {
              password: this.formInput.password,
              telefono: this.formInput.ntelefono,
              email: this.formInput.email,
              nome_azienda: this.formInput.ragionesociale,
              indirizzo: this.formInput.indirizzo,
              username: this.formInput.username,
              partitaiva: this.formInput.partitaiva,
              cap: this.formInput.cap,
              comune: this.formInput.comune,
              provincia: this.formInput.comune,
              fax: this.formInput.fax,


            }
          })
              .then(esito => {
                loadingComponent.close()
                this.alertSuccess(this.formInput.username)


              })
              .catch(err => {

                this.errorToast(err.response.data.message)
                loadingComponent.close()
                for (let key in this.messageInput) {
                  this.messageInput[key].message = ''
                  this.messageInput[key].error = false
                }
              })
        } else {
          loadingComponent.close()
          this.errorToast('Alcuni campi presentano degli errori')
        }
      } else {
        loadingComponent.close()
        this.messageInput.password2.message = 'Le password non corrispondono!'
        this.messageInput.password.error = true
        this.messageInput.password2.error = true
      }


    },


  }

}
</script>

<style lang="scss">
/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
.section .section-container {
  max-width: calc(100% - var(--public-menu-width));
  margin: 0 0 0 var(--public-menu-width);
}

@media screen and (max-width: 1220px) {
  .section .section-container {
    max-width: 95%;
    margin: auto;
  }
}

/*
 * payoff
*/
.payoff {
  font-size: 60px;
  font-weight: lighter;
}

@media screen and (max-width: 750px) {
  .payoff {
    font-size: 2.4em;
  }
}

@media screen and (max-width: 400px) {
  .payoff {
    font-size: 2em;
  }
}


.section.top,
.section.bgi {
  width: 100%;
  height: 100vh;
  color: white;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: cover;
  background-position: initial;
}

.section.bgi {
  background-size: contain;
}

.section-sub {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.std {
  width: 100%;
  height: 100vh;
  background-color: var(--black-2);
}

.section.top {
  padding-top: 0;

  .section-container-center-mode {
    margin-left: var(--public-menu-width);
  }
}

.section.top .content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  h2 {
    color: #fff;
    padding-top: 10px;
  }

  .form-register {
    border-radius: 5px;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //background-color: rgba(0, 0, 0, .4);
    //backdrop-filter: blur(24px);
    width: 80%;


    hr {
      margin-bottom: 12px;
      margin-top: 0;
    }

    .btns {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
  }
}

.link-ret.green {
  border-radius: 4px;
  &:hover {
    background-color: #A6F93470;
  }
}

.link-ret.btn-my-primary.black {
  border-radius: 4px;
  &::after {
    transform: rotate(-135deg);
    left: 0;
  }

  &:hover::after {
    border: 1px solid;
    border-bottom: none;
    border-left: none;
    left: -1.6em;
  }
}

.section.top .content h1 {
  font-size: 60px;
  font-weight: lighter;
}

.section.std .content .text {
  color: white;
  width: 100%;
  max-width: 95%;
  width: 760px;
  margin: auto;
}

.section.std .content .text h1 {
  /* margin-bottom: 0; */
  font-weight: 500;
}

.section.std .content .text p {
  margin: 0;
  font-weight: 300;
  color: var(--text-white);
}

.section:not(.gallery) .content,
.section-sub .content {

  max-width: 1000px;
  margin: auto;
  position: relative;
}

.section .wrapper-data {
  width: 100%;
  margin-top: 20px;
}

.notices .toast {
  flex-basis: 0;
}

//.content-gallery {
//  width: 100%;
//  /* max-width: 1400px; */
//  margin: auto;
//  position: relative;
//}
//.content-gallery .slick-slider{
//  margin-left: -180px;
//}
//.content-source-media {
//  /* width: 100%; */
//  /* max-width: 500px; */
//  width: auto;
//  /* min-height: 500px; */
//}
//.content-source-media .source {
//  width: inherit;
//}
//.content-source-media .source img {
//  display: block;
//  width: inherit;
//  padding: 2em;
//  transition: padding 0.2s 0.2s ease-in-out;
//}
//.slick-slide[aria-hidden="false"]:not(.slick-current) .source img {
//  opacity: 0.4;
//}
//.slick-slide[aria-hidden="true"] .source img {
//  opacity: 0.1;
//}
//
//.slick-slide.slick-current {
//  z-index: 2;
//  position: relative;
//}
//.slick-slide.slick-current .source img{
//  padding: 0;
//  opacity: 1;
//}
//
//
//
///* .slick-prev, .slick-next {
//
//}
//.slick-prev::before, .slick-next::before {
//	font-family: 'Jost';
//	font-size: 1em;
//	line-height: 1;
//	opacity: 1;
//	color: white;
//} */
//
//.slick-prev::before,
//.slick-next::before {
//  content: '';
//  /* display: inline-block;
//  position: absolute;
//  background-repeat: no-repeat;
//  background-origin: initial;
//  background-clip: initial;
//  background-size: 100% auto;
//  background-position: center;
//  background-image: url("https://4belt.ululabdev.it/media/icons/svg/arrow-white.svg"); */
//}
//.btn-circle.arrow{
//  display: flex;
//  align-items: center;
//  justify-content: center;
//}
//.btn-circle.slick-prev {
//  top: 110px;
//  left: 70%;
//}
//.btn-circle.slick-next {
//  bottom: 40px;
//  left: 70%;
//}
//.btn-circle.arrow span {
//  width: 48px;
//  height: 22px;
//  display: inline-block;
//  position: absolute;
//  background-repeat: no-repeat;
//  background-origin: initial;
//  background-clip: initial;
//  background-size: 100% auto;
//  background-position: center;
//}
//.btn-circle.slick-prev span {
//  -webkit-transform: rotate(180deg);
//  transform: rotate(180deg);
//}
///* ---------------------------- */
//
//.fp-tableCell{
//  position: relative;
//}


</style>
